
 /**
 * Event `Map.ChangeLayerVisibility`
 *
 * @typedef {Object} MultSceneForApp~Map~Events~ChangeLayerVisibility
 * @property {string} type - type of event, has value `map.changelayervisibility`
 * @property {String} id - ID of layer
 * @property {Boolean} visibility - visibility of layer
 */

export default function createEventChangeLayerVisibility(id, visibility) {
    return {
        type: 'map.changelayervisibility',
        id: id,
        visibility: visibility
    };
}
